/**
 * Brand glyph SVGs we render inline next to the
 * "Continue with Google" / "Continue with Apple" buttons. Inline
 * rather than fetched assets so the buttons paint without a flash
 * on the first cold render of the login page.
 *
 * Both glyphs are rendered at 16×16 inside an h-4 w-4 container.
 * The Google mark uses Google's official brand colours; the Apple
 * mark uses `currentColor` so it inherits from button text (looks
 * right against both light and dark surfaces).
 */
export const GoogleIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      fill="#4285F4"
      d="M15.68 8.18c0-.57-.05-1.12-.15-1.64H8v3.1h4.31a3.69 3.69 0 0 1-1.6 2.42v2.01h2.59c1.51-1.4 2.38-3.46 2.38-5.89z"
    />
    <path
      fill="#34A853"
      d="M8 16c2.16 0 3.97-.72 5.3-1.95l-2.59-2.01c-.72.48-1.63.77-2.71.77-2.08 0-3.84-1.4-4.47-3.29H.86v2.07A8 8 0 0 0 8 16z"
    />
    <path
      fill="#FBBC05"
      d="M3.53 9.52A4.8 4.8 0 0 1 3.27 8c0-.53.09-1.04.26-1.52V4.41H.86A8 8 0 0 0 0 8c0 1.29.31 2.52.86 3.59l2.67-2.07z"
    />
    <path
      fill="#EA4335"
      d="M8 3.18c1.18 0 2.23.4 3.06 1.2l2.3-2.3C11.97.79 10.16 0 8 0A8 8 0 0 0 .86 4.41l2.67 2.07C4.16 4.59 5.92 3.18 8 3.18z"
    />
  </svg>
);

export const AppleIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M11.18 8.51c-.02-1.96 1.6-2.91 1.67-2.95-.91-1.32-2.32-1.5-2.83-1.52-1.21-.12-2.36.71-2.97.71-.62 0-1.56-.69-2.57-.67-1.32.02-2.54.77-3.22 1.95-1.37 2.39-.35 5.93.99 7.87.65.95 1.43 2.02 2.44 1.98.99-.04 1.36-.64 2.55-.64 1.18 0 1.52.64 2.56.62 1.06-.02 1.73-.96 2.38-1.92.75-1.1 1.06-2.18 1.08-2.24-.02-.01-2.07-.79-2.08-3.13zM9.27 2.78c.55-.66.92-1.59.81-2.51-.79.03-1.74.53-2.31 1.19-.51.58-.96 1.51-.84 2.41.88.07 1.78-.45 2.34-1.09z" />
  </svg>
);
